const jobViewOriginMap: Record<string, string> = {
  applied: 'My Activity (Applied)',
  'applied-recom': 'My Activity (Applied) Recommended Jobs',
  'company-profile': 'Company Profile',
  'post-apply-recs': 'Post-Apply Recommended Jobs',
  'profile-recom': 'Talent Search Insights',
  'recom-homepage': 'Home Recommended Jobs',
  'recom-homepage-genai': 'Home Recommended Jobs (GenAI)',
  'recom-split': 'Recommended Jobs (Splitview)',
  'recom-split-newtab': 'Recommended Jobs (Splitview - New Tab)',
  'recom-standalone': 'Recommended Jobs (Standalone)',
  'cp-recs': 'Competitive Recommended Jobs',
  saved: 'My Activity (Saved)',
  savedsearch: 'Saved Search Jobs',
  'saved-homepage': 'Home Saved Jobs',
  'search-split': 'Search Results (Splitview)',
  'search-split-newtab': 'Search Results (Splitview - New Tab)',
  'search-standalone': 'Search Results (Standalone)',
  'SKL-CareerGuide': 'Career Guide',
};

export const getJobViewOrigin = (recQuery: string | undefined) => ({
  jobViewOrigin: recQuery ? jobViewOriginMap[recQuery] : 'Others',
});
